export const FIELDS_NAMES = {
  NAME: 'name',
  AUTO_ADD_NEW_TESTS: 'autoAddNewTests',
  AUTO_RETRY: 'autoRetry',
  RUN_IN_PARALLEL: 'runInParallel',
  TESTS: 'tests',
  PROFILE: 'runProfileId',
};
